const n = [
  "IconAddImage",
  "IconAddToCart",
  "IconAlert",
  "IconAlertFilled",
  "IconArchive",
  "IconArrowDown",
  "IconArrowDownLeft",
  "IconArrowDownRight",
  "IconArrowLeft",
  "IconArrowRight",
  "IconArrowUp",
  "IconArrowUpLeft",
  "IconArrowUpRight",
  "IconAttachment",
  "IconAvatar",
  "IconAvatarFilled",
  "IconBackMarket",
  "IconBackMarketApp",
  "IconBackMarketAvatar",
  "IconBackMarketPromise",
  "IconBackMarketPromiseFilled",
  "IconBadge",
  "IconBank",
  "IconBankIn",
  "IconBankOut",
  "IconBattery",
  "IconBellAlert",
  "IconBellDisabled",
  "IconBellFilled",
  "IconBellOutlined",
  "IconBike",
  "IconBill",
  "IconBlocked",
  "IconBluetooth",
  "IconBolt",
  "IconBoltDisabled",
  "IconBoltFilled",
  "IconBurger",
  "IconCalendar",
  "IconCalendarWithCheck",
  "IconCamera",
  "IconCameraViewfinder",
  "IconCardView",
  "IconCellSignal",
  "IconChargingWire",
  "IconChart",
  "IconCharter",
  "IconCheckInCircle",
  "IconCheckInCircleFilled",
  "IconCheckLarge",
  "IconCheckSmall",
  "IconCheckWithSparkles",
  "IconChevronDown",
  "IconChevronLeft",
  "IconChevronRight",
  "IconChevronUp",
  "IconCircle",
  "IconClock",
  "IconComment",
  "IconCompare",
  "IconCompass",
  "IconComputerMouse",
  "IconContact",
  "IconController",
  "IconCookie",
  "IconCopy",
  "IconCpu",
  "IconCreditCard",
  "IconCross",
  "IconCrosshair",
  "IconCrossInCircle",
  "IconCrossInCircleFilled",
  "IconCrossInCircleFilledSmall",
  "IconCrossSmall",
  "IconCupcake",
  "IconCurrencyAustralianDollar",
  "IconCurrencyDollar",
  "IconCurrencyEuro",
  "IconCurrencyPound",
  "IconCurrencySwedishKrone",
  "IconCurrencyYen",
  "IconCycle",
  "IconDeal",
  "IconDealFilled",
  "IconDesign",
  "IconDiamond",
  "IconDoubleChevronSideways",
  "IconDoubleChevronUp",
  "IconDownload",
  "IconEdit",
  "IconEiffelTower",
  "IconEqual",
  "IconEqualizer",
  "IconEqualizerSmall",
  "IconExpand",
  "IconExport",
  "IconExpressReplacement",
  "IconExternalLink",
  "IconEyeClosed",
  "IconEyeOpen",
  "IconEyes",
  "IconFactory",
  "IconFigma",
  "IconFile",
  "IconFingerprint",
  "IconFire",
  "IconFireFilled",
  "IconFlag",
  "IconFloat",
  "IconGear",
  "IconGearUpdate",
  "IconGift",
  "IconGitHubFilled",
  "IconGlasses",
  "IconGlobe",
  "IconGoldenGate",
  "IconGpu",
  "IconGrade",
  "IconGrowth",
  "IconHdmi",
  "IconHeadset",
  "IconHeart",
  "IconHeartBroken",
  "IconHeartDiagnostic",
  "IconHeartExploded",
  "IconHeartFilled",
  "IconHome",
  "IconHomeFilled",
  "IconImage",
  "IconInboxTray",
  "IconInfo",
  "IconInfoFilled",
  "IconKeyboard",
  "IconLanguage",
  "IconLaptop",
  "IconLaptopCamera",
  "IconLeaf",
  "IconLightbulb",
  "IconListView1",
  "IconListView2",
  "IconListViewChecks",
  "IconLocationPinFilled",
  "IconLocationPinOutlined",
  "IconLockLocked",
  "IconLockUnlocked",
  "IconLogOut",
  "IconMagsafe",
  "IconMail",
  "IconMedal",
  "IconMediaPause",
  "IconMediaPlay",
  "IconMediaStop",
  "IconMegaphone",
  "IconMinus",
  "IconMinusInCircle",
  "IconMoney",
  "IconMoreHorizontal",
  "IconMoreVertical",
  "IconMove",
  "IconOfficial",
  "IconOfficialFilled",
  "IconPackage",
  "IconPaintBrush",
  "IconPeople",
  "IconPercentage",
  "IconPerformance",
  "IconPlug",
  "IconPlus",
  "IconPlusInCircle",
  "IconPower",
  "IconPowerAdapterApple",
  "IconPriceTag",
  "IconPriceTagFilled",
  "IconPriceUpdate",
  "IconPrint",
  "IconPromo",
  "IconQuality",
  "IconQuestionMarkInCircle",
  "IconRecommendation",
  "IconRefresh",
  "IconRefund",
  "IconRepairHome",
  "IconRepairMailIn",
  "IconRepairSelf",
  "IconRepairStore",
  "IconRocket",
  "IconScooter",
  "IconScratches",
  "IconSdhcCard",
  "IconSearch",
  "IconSearchFilled",
  "IconSend",
  "IconShare",
  "IconShareAndroid",
  "IconShop",
  "IconShopFilled",
  "IconShoppingBag",
  "IconSim",
  "IconSiren",
  "IconSmartphone",
  "IconSmartphoneBroken",
  "IconSmartphoneCamera",
  "IconSmartphoneFilled",
  "IconSmartphoneScreenSize",
  "IconSort",
  "IconSos",
  "IconSoundLow",
  "IconSoundOff",
  "IconSoundOn",
  "IconSparkles",
  "IconSpinner",
  "IconStarFilled",
  "IconStarHalf",
  "IconStarOutlined",
  "IconSwap",
  "IconSwapFilled",
  "IconTablet",
  "IconThumbsDownFilled",
  "IconThumbsDownOutlined",
  "IconThumbsUpFilled",
  "IconThumbsUpOutlined",
  "IconTools",
  "IconTouch",
  "IconTouchbar",
  "IconTrade",
  "IconTrash",
  "IconTrophy",
  "IconTruck",
  "IconTruckExpress",
  "IconTv",
  "IconUndo",
  "IconUpload",
  "IconWarning",
  "IconWatch",
  "IconWaterdrop",
  "IconWifi",
  "IconReassuranceAdyen",
  "IconReassuranceArrowFilled",
  "IconReassuranceArrowOutlined",
  "IconReassuranceCalendar14Days",
  "IconReassuranceCalendar30Days",
  "IconReassuranceCertified",
  "IconReassuranceConfianza",
  "IconReassuranceCreditCardFilled",
  "IconReassuranceCreditCardOutlined",
  "IconReassuranceFevad",
  "IconReassuranceGlobeFilled",
  "IconReassuranceGlobeOutlined",
  "IconReassuranceGoogle",
  "IconReassuranceLockFilled",
  "IconReassuranceLockOutlined",
  "IconReassuranceParcelFilled",
  "IconReassuranceParcelOutlined",
  "IconReassuranceShield12Months",
  "IconReassuranceShield24Months",
  "IconReassuranceShield36Months",
  "IconReassuranceShield6Months",
  "IconReassuranceShieldFilled",
  "IconReassuranceShieldOutlined",
  "IconReassuranceSmileyFilled",
  "IconReassuranceSmileyOutlined",
  "IconReassuranceTruckFilled",
  "IconReassuranceTruckOutlined",
  "IconReassuranceTrustedShops",
  "IconSunBeam",
  "IconSunFace",
  "IconAi"
];
export {
  n as iconNames
};
